import styled from 'styled-components';
import { Radio } from 'antd';

export const RadioGroupWrapper = styled(Radio.Group)``;
